var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishTrialCls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8125 17.5875C14.9875 17.1375 14.875 16.625 14.525 16.275L11.9125 13.7L11.95 13.6625C14.125 11.2375 15.675 8.45 16.5875 5.5H19.0125C19.6875 5.5 20.25 4.9375 20.25 4.2625V4.2375C20.25 3.5625 19.6875 3 19.0125 3H11.5V1.75C11.5 1.0625 10.9375 0.5 10.25 0.5C9.5625 0.5 9 1.0625 9 1.75V3H1.4875C0.8125 3 0.25 3.5625 0.25 4.2375C0.25 4.925 0.8125 5.475 1.4875 5.475H14.2125C13.375 7.9 12.05 10.1875 10.25 12.1875C9.2375 11.075 8.3875 9.8625 7.675 8.5875C7.475 8.225 7.1125 8 6.7 8C5.8375 8 5.2875 8.9375 5.7125 9.6875C6.5 11.1 7.4625 12.45 8.5875 13.7L3.125 19.0875C2.625 19.575 2.625 20.375 3.125 20.8625C3.6125 21.35 4.4 21.35 4.9 20.8625L10.25 15.5L12.775 18.025C13.4125 18.6625 14.5 18.425 14.8125 17.5875ZM20.875 10.5C20.125 10.5 19.45 10.9625 19.1875 11.675L14.6 23.925C14.3 24.6875 14.875 25.5 15.6875 25.5C16.175 25.5 16.6125 25.2 16.7875 24.7375L17.9 21.75H23.8375L24.9625 24.7375C25.1375 25.1875 25.575 25.5 26.0625 25.5C26.875 25.5 27.45 24.6875 27.1625 23.925L22.575 11.675C22.3 10.9625 21.625 10.5 20.875 10.5ZM18.85 19.25L20.875 13.8375L22.9 19.25H18.85Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishTrialCls);
export default __webpack_public_path__ + "static/media/english_trial_cls.1b4412c8d1243fffaf5dcfa94818f2c6.svg";
export { ForwardRef as ReactComponent };